import { useState } from "react";
import "./App.css";
import FavoritePets from "./components/FavoritePets";
import MainPage from "./components/MainPage";
import Quizz from "./components/Quizz";
import ResultPage from "./components/ResultPage";
import Home from "./components/Home";
import FavoritesPage from "./components/FavoritesPage";
import Pets from "./components/Pets";

function App() {
  const [currPage, setCurrPage] = useState("main");
  const [favoritePets, setFavoritePets] = useState([]);
  const [quizAnswers, setQuizAnswers] = useState([]);

  const addToFavorites = (pet) => {
    if (!favoritePets.some((favPet) => favPet.id === pet.id)) {
      setFavoritePets([...favoritePets, pet]);
    }
  };

  const removeFromFavorites = (petId) => {
    setFavoritePets(favoritePets.filter((pet) => pet.id !== petId));
  };

  const navigateTo = (page) => {
    setCurrPage(page);
  };

  return (
    <div className="App">
      {currPage === "main" && (
        <MainPage onStartQuizz={() => navigateTo("quizz")} />
      )}
      {currPage === "quizz" && (
        <Quizz
          onComplete={(answers) => {
            setQuizAnswers(answers);
            navigateTo("results");
          }}
        />
      )}
      {currPage === "results" && (
        <ResultPage
          quizAnswers={quizAnswers}
          addToFavorites={addToFavorites}
          removeFromFavorites={removeFromFavorites}
          favoritePets={favoritePets}
        />
      )}{" "}
      {currPage === "favorites" && (
        <FavoritesPage
          addToFavorites={addToFavorites}
          removeFromFavorites={removeFromFavorites}
          favoritePets={favoritePets}
        />
      )}
      <Home onGoHome={() => navigateTo("main")} />
      {currPage === "favorites" && (
        <Pets onBackToResults={() => navigateTo("results")} />
      )}
      <FavoritePets onFavorites={() => navigateTo("favorites")} />
    </div>
  );
}
export default App;
